export const NETWORKS = 'networks';
export const PLATFORMS = 'platforms';
export const APPLICATIONS = 'applications';
export const EXCLUDE_APPLICATIONS = 'excludeApplications';
export const ONLY_APPLICATIONS = 'onlyApplication';
export const TRAFFIC_TYPE = 'trafficType';
export const COUNTRIES = 'countryCodes';
export const AFFILIATES = 'affiliates';
export const DEVICES = 'devices';
export const OSVERSIONS = 'osVersions';
export const IS_INCLUDE_BOTS = 'isBotIncluded';
export const TRAFFIC_TYPE_ADVERTISING = 1;
export const TRAFFIC_TYPE_ALL = 0;

export const isAdvertisingTrafficType = (trafficType) =>
  trafficType === TRAFFIC_TYPE_ADVERTISING;

const MOBILE_NETWORK_ID = 30;
export const hasMobileNetworks = (networks) => {
  if (!Array.isArray(networks)) {
    return false;
  }
  return networks.includes(MOBILE_NETWORK_ID);
};
